module.exports = __webpack_public_path__ + "static/media/arrow_back_off.4aac8bbc.svg";